import { getTgBotRole } from '#shared/lib/auth'
import httpClient from './http-client'
import resolveApiUrl from './resolve-api-url'

interface AuthResponse {
  access_token: string
  refresh_token: string
}

export default async function getTgTokens() {
  const botRole = getTgBotRole()
  const path = `${botRole}/users/${Telegram.WebApp.initDataUnsafe.user?.id}/tokens`

  const authResponse = await httpClient.get<AuthResponse>(path, {
    headers: {
      'telegram-init-data': Telegram.WebApp.initData,
    },
    prefixUrl: resolveApiUrl('@sd-tg-bot'),
    skipAuth: true,
  })

  const parsedAuthResponse = await authResponse.json()

  return parsedAuthResponse
}
